var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "control" }, [
    _c(
      "div",
      { staticClass: "form-group input-group" },
      [
        _c("datepicker", {
          attrs: {
            id: "form-" + _vm.parent.specification,
            "input-class": "date-control",
            placeholder: "Select Date",
            "clear-button": true
          },
          on: { input: _vm.updateFilters },
          model: {
            value: _vm.query,
            callback: function($$v) {
              _vm.query = $$v
            },
            expression: "query"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }